import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';

import { CelumIcon, IconConfiguration } from '@celum/common-components/icon';

@Component({
  selector: 'celum-collapse-button',
  templateUrl: './collapse-button.component.html',
  styleUrls: ['./collapse-button.component.less'],
  imports: [CelumIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class CelumCollapseButtonComponent {
  @Input() public collapsed = false;
  @Input() public verticalOrientation = false;

  @Output() public readonly changed = new EventEmitter<void>();

  @HostBinding('class.collapse-button') public hostCls = true;

  public icons = {
    arrow: IconConfiguration.small('play-m')
  };
}
